/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalEhrType } from './ExternalEhrType';
import {
    ExternalEhrTypeFromJSON,
    ExternalEhrTypeFromJSONTyped,
    ExternalEhrTypeToJSON,
} from './ExternalEhrType';
import type { Lead } from './Lead';
import {
    LeadFromJSON,
    LeadFromJSONTyped,
    LeadToJSON,
} from './Lead';

/**
 * 
 * @export
 * @interface ExternalEhrPatient
 */
export interface ExternalEhrPatient {
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrPatient
     */
    patient_id?: string;
    /**
     * 
     * @type {ExternalEhrType}
     * @memberof ExternalEhrPatient
     */
    type?: ExternalEhrType;
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrPatient
     */
    details_push_date?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalEhrPatient
     */
    details_extraction_date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalEhrPatient
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalEhrPatient
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalEhrPatient
     */
    is_generated_document_upload_in_progress?: boolean;
    /**
     * 
     * @type {Array<Lead>}
     * @memberof ExternalEhrPatient
     */
    leads?: Array<Lead>;
}

/**
 * Check if a given object implements the ExternalEhrPatient interface.
 */
export function instanceOfExternalEhrPatient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExternalEhrPatientFromJSON(json: any): ExternalEhrPatient {
    return ExternalEhrPatientFromJSONTyped(json, false);
}

export function ExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrPatient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'type': !exists(json, 'type') ? undefined : ExternalEhrTypeFromJSON(json['type']),
        'details_push_date': !exists(json, 'details_push_date') ? undefined : json['details_push_date'],
        'details_extraction_date': !exists(json, 'details_extraction_date') ? undefined : json['details_extraction_date'],
        'is_screener_document_upload_in_progress': !exists(json, 'is_screener_document_upload_in_progress') ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': !exists(json, 'is_additional_document_upload_in_progress') ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': !exists(json, 'is_generated_document_upload_in_progress') ? undefined : json['is_generated_document_upload_in_progress'],
        'leads': !exists(json, 'leads') ? undefined : ((json['leads'] as Array<any>).map(LeadFromJSON)),
    };
}

export function ExternalEhrPatientToJSON(value?: ExternalEhrPatient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'type': ExternalEhrTypeToJSON(value.type),
        'details_push_date': value.details_push_date,
        'details_extraction_date': value.details_extraction_date,
        'is_screener_document_upload_in_progress': value.is_screener_document_upload_in_progress,
        'is_additional_document_upload_in_progress': value.is_additional_document_upload_in_progress,
        'is_generated_document_upload_in_progress': value.is_generated_document_upload_in_progress,
        'leads': value.leads === undefined ? undefined : ((value.leads as Array<any>).map(LeadToJSON)),
    };
}

